enum DeviceRole {
  Gatekeeper = 'gatekeeper',
  PaymentSystem = 'paymentSystem',
  PointOfSale = 'pointOfSale',
}

export default DeviceRole;
